// ---------------------------------------------------------------------------
// openPrintUrl(url)
//
// Open a print-oriented URL (like /print/reports/... or /print/student/...)
// in a way that survives popup blockers.
//
// Historically these routes were opened with `window.open(url, '_blank')`.
// That works in most desktop browsers when called synchronously from a
// user click, but a growing list of environments silently return `null`:
//
//   * Chrome / Edge with "Sites can send pop-ups" set to Blocked
//   * Firefox strict tracking protection with popup blocking on
//   * Safari desktop when the page is inside an iframe (some SIS wrappers)
//   * Safari iOS in general, which is aggressive about `_blank`
//   * Cursor's / VS Code's embedded browser preview panels
//
// When that happens the printer button appears to do nothing, which is
// exactly what our teachers reported ("clicked Print, nothing happens").
//
// The safe pattern is: attempt the new-tab open first, and if the browser
// hands back a null window (== popup was blocked) fall back to a
// same-tab navigation to the same URL. Every print route in the app has
// a "Back" button in its toolbar, so a same-tab navigation is a fine
// fallback — the user still gets to the print page and their browser's
// print dialog still opens (the print pages call `window.print()`
// themselves via ?autoprint=1).
// ---------------------------------------------------------------------------
export function openPrintUrl(url) {
  if (typeof window === 'undefined' || !url) return;

  let popup = null;
  try {
    popup = window.open(url, '_blank');
    if (popup) {
      try {
        popup.opener = null;
      } catch {
        // Some browsers freeze `opener`; ignore, we only meant to
        // disown the reference for tabnabbing protection.
      }
    }
  } catch {
    popup = null;
  }

  if (!popup) {
    window.location.href = url;
  }
}
